(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6456],{

/***/ 38144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/StyledCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 3s ease infinite;\n      background-size: 400% 400%;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  ",
        "\n\n  padding: 1px 1px 3px 1px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow: ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var PromotedGradient = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
/**
 * Priority: Warning --> Success --> Active
 */ var getBorderColor = function getBorderColor(param) {
    var isActive = param.isActive, isSuccess = param.isSuccess, isWarning = param.isWarning, borderBackground = param.borderBackground, theme = param.theme;
    if (borderBackground) {
        return borderBackground;
    }
    if (isWarning) {
        return theme.colors.warning;
    }
    if (isSuccess) {
        return theme.colors.success;
    }
    if (isActive) {
        return "linear-gradient(180deg, ".concat(theme.colors.primaryBright, ", ").concat(theme.colors.secondary, ")");
    }
    return theme.colors.cardBorder;
};
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eecfaa46-0"
}).withConfig({
    componentId: "sc-62e22978-0"
})(_templateObject2(), getBorderColor, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme, isDisabled = param.isDisabled;
    return theme.colors[isDisabled ? "textDisabled" : "text"];
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), PromotedGradient);
}, index_esm/* space */.Dh);
var StyledCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-eecfaa46-1"
}).withConfig({
    componentId: "sc-62e22978-1"
})(_templateObject3(), function(param) {
    var hasCustomBorder = param.hasCustomBorder;
    return hasCustomBorder ? "initial" : "inherit";
}, function(param) {
    var theme = param.theme, background = param.background;
    return background !== null && background !== void 0 ? background : theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
StyledCard.defaultProps = {
    isActive: false,
    isSuccess: false,
    isWarning: false,
    isDisabled: false
};

;// CONCATENATED MODULE: ./packages/uikit/src/components/Card/Card.tsx






var Card = function Card(_param) {
    var ribbon = _param.ribbon, children = _param.children, background = _param.background, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ribbon",
        "children",
        "background"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            background: background,
            hasCustomBorder: !!props.borderBackground,
            children: [
                ribbon,
                children
            ]
        })
    }));
};
/* harmony default export */ var Card_Card = (Card);


/***/ }),

/***/ 97810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17058);





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.71005 11.71L11.3001 14.3C11.6901 14.69 12.3201 14.69 12.7101 14.3L15.3001 11.71C15.9301 11.08 15.4801 10 14.5901 10H9.41005C8.52005 10 8.08005 11.08 8.71005 11.71Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 37370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44850);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97810);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 16px;\n  box-shadow: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 16px;\n  background: ",
        ";\n  transition: border-radius 0.15s;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 70px;\n  height: 0;\n  position: absolute;\n  overflow: hidden;\n  background: ",
        ";\n  z-index: ",
        ";\n  transition: transform 0.15s, opacity 0.15s;\n  transform: scaleY(0);\n  transform-origin: top;\n  opacity: 0;\n  width: 100%;\n\n  ",
        " {\n    min-width: 70px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        " {\n        border-bottom: 1px solid ",
        ";\n        box-shadow: ",
        ";\n        border-radius: 16px 16px 0 0;\n      }\n\n      ",
        " {\n        height: auto;\n        transform: scaleY(1);\n        opacity: 1;\n        border: 1px solid ",
        ";\n        border-top-width: 0;\n        border-radius: 0 0 16px 16px;\n        box-shadow: ",
        ";\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  position: relative;\n  background: ",
        ";\n  border-radius: 16px;\n  height: 40px;\n  min-width: 136px;\n  user-select: none;\n  z-index: 20;\n\n  ",
        " {\n    min-width: 120px;\n  }\n\n  ",
        "\n\n  svg {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  z-index: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  list-style: none;\n  padding: 8px 16px;\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var DropDownHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-eda324a3-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.shadows.inset;
}, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.input;
});
var DropDownListContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-eda324a3-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var DropDownContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-eda324a3-2"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(props) {
    return props.isOpen && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), DropDownHeader, function(param) {
        var theme = param.theme;
        return theme.colors.inputSecondary;
    }, function(param) {
        var theme = param.theme;
        return theme.tooltip.boxShadow;
    }, DropDownListContainer, function(param) {
        var theme = param.theme;
        return theme.colors.inputSecondary;
    }, function(param) {
        var theme = param.theme;
        return theme.tooltip.boxShadow;
    });
});
var DropDownList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-eda324a3-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-eda324a3-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
});
var Select = function(_param) {
    var options = _param.options, onOptionChange = _param.onOptionChange, _defaultOptionIndex = _param.defaultOptionIndex, defaultOptionIndex = _defaultOptionIndex === void 0 ? 0 : _defaultOptionIndex, placeHolderText = _param.placeHolderText, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "options",
        "onOptionChange",
        "defaultOptionIndex",
        "placeHolderText"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), optionSelected = ref1[0], setOptionSelected = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultOptionIndex), selectedOptionIndex = ref2[0], setSelectedOptionIndex = ref2[1];
    var toggling = function(event) {
        setIsOpen(!isOpen);
        event.stopPropagation();
    };
    var onOptionClicked = function(selectedIndex) {
        return function() {
            setSelectedOptionIndex(selectedIndex);
            setIsOpen(false);
            setOptionSelected(true);
            if (onOptionChange) {
                onOptionChange(options[selectedIndex]);
            }
        };
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleClickOutside = function() {
            setIsOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DropDownContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        isOpen: isOpen
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownHeader, {
                onClick: toggling,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    color: !optionSelected && placeHolderText ? "text" : undefined,
                    children: !optionSelected && placeHolderText ? placeHolderText : options[selectedOptionIndex].label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                color: "text",
                onClick: toggling
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownListContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownList, {
                    children: options.map(function(option, index) {
                        return placeHolderText || index !== selectedOptionIndex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListItem, {
                            onClick: onOptionClicked(index),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                children: option.label
                            })
                        }, option.label) : null;
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 83362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _address_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 5 modules
var src = __webpack_require__(8253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(38144);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(83559);
// EXTERNAL MODULE: ./src/components/Menu/index.tsx + 19 modules
var Menu = __webpack_require__(17372);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/infoV2/actions.ts
var actions = __webpack_require__(69804);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/state/infoV2/hook/fectData.ts



var fetchListDataChart = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, response, arrayData, i;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return axios_default()({
                        method: "GET",
                        url: "https://dog-watcher-api.deltalabsjsc.com:4001/api/v1/tokens"
                    });
                case 3:
                    ref = _ctx.sent;
                    response = ref.data;
                    arrayData = [];
                    for(i = 0; i < response.data.length; i++){
                        arrayData.push({
                            amount: response.data[i].amount,
                            buyCurrency: response.data[i].buyCurrency,
                            close: Number(response.data[i].close),
                            high: response.data[i].high,
                            low: response.data[i].low,
                            open: Number(response.data[i].open),
                            price: response.data[i].price,
                            sellCurrency: response.data[i].sellCurrency,
                            time: response.data[i].timeInterval,
                            trades: response.data[i].trades,
                            volume: response.data[i].volume
                        });
                    }
                    return _ctx.abrupt("return", {
                        dataChart: arrayData
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    // eslint-disable-next-line no-console
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        dataChart: []
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return function fetchListDataChart() {
        return _ref.apply(this, arguments);
    };
}();
var fetchListData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, response, arrayData, i;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return axios_default()({
                        method: "GET",
                        url: "https://dog-watcher-api.deltalabsjsc.com:4001/api/v1/token"
                    });
                case 3:
                    ref = _ctx.sent;
                    response = ref.data;
                    arrayData = [];
                    for(i = 0; i < response.data.length; i++){
                        arrayData.push({
                            amount: response.data[i].amount,
                            buyCurrency: response.data[i].buyCurrency,
                            close: Number(response.data[i].close),
                            high: response.data[i].high,
                            low: response.data[i].low,
                            open: Number(response.data[i].open),
                            price: response.data[i].price,
                            sellCurrency: response.data[i].sellCurrency,
                            time: response.data[i].timeInterval,
                            trades: response.data[i].trades,
                            volume: response.data[i].volume
                        });
                    }
                    return _ctx.abrupt("return", {
                        dataToken: arrayData
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    // eslint-disable-next-line no-console
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        dataToken: []
                    });
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return function fetchListData() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/state/infoV2/index.ts






var GetDataChart = function() {
    var data = (0,es/* useSelector */.v9)(function(state) {
        return state.infoV2;
    });
    var dataChart = data.dataChart;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var getDataChart = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var result;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return fetchListDataChart();
                        case 3:
                            result = _ctx.sent;
                            dispatch((0,actions/* fetchDataChart */.d)(result));
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }));
            return function getDataChart() {
                return _ref.apply(this, arguments);
            };
        }();
        getDataChart();
    }, [
        dispatch
    ]);
    return [
        dataChart
    ];
};
var GetDataToken = function() {
    var data = (0,es/* useSelector */.v9)(function(state) {
        return state.infoV2;
    });
    var dataToken = data.dataToken;
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var getData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var result;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return fetchListData();
                        case 3:
                            result = _ctx.sent;
                            dispatch((0,actions/* fetchData */.r)(result));
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log("error");
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }));
            return function getData() {
                return _ref.apply(this, arguments);
            };
        }();
        getData();
    }, [
        dispatch
    ]);
    return [
        dataToken
    ];
};

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/utils/formatInfoNumbers.ts
var formatInfoNumbers = __webpack_require__(56245);
// EXTERNAL MODULE: ./src/views/Info/components/InfoCharts/ChartCard/index.tsx
var ChartCard = __webpack_require__(5004);
// EXTERNAL MODULE: ./src/views/Info/components/InfoTables/config.tsx
var config = __webpack_require__(85224);
;// CONCATENATED MODULE: ./src/views/Info/components/InfoTables/configChart.ts
var DataChart = [
    {
        date: 1670924651,
        volumeUSD: 10,
        liquidityUSD: 10
    },
    {
        date: 1670924651,
        volumeUSD: 20,
        liquidityUSD: 20
    },
    {
        date: 1670924651,
        volumeUSD: 30,
        liquidityUSD: 30
    },
    {
        date: 1670924651,
        volumeUSD: 40,
        liquidityUSD: 40
    },
    {
        date: 1670924651,
        volumeUSD: 50,
        liquidityUSD: 50
    },
    {
        date: 1670924651,
        volumeUSD: 60,
        liquidityUSD: 60
    },
    {
        date: 1670924651,
        volumeUSD: 70,
        liquidityUSD: 70
    },
    {
        date: 1670924651,
        volumeUSD: 10,
        liquidityUSD: 10
    },
    {
        date: 1670924651,
        volumeUSD: 40,
        liquidityUSD: 40
    },
    {
        date: 1670924651,
        volumeUSD: 70,
        liquidityUSD: 70
    },
    {
        date: 1670924651,
        volumeUSD: 20,
        liquidityUSD: 20
    },
    {
        date: 1670924651,
        volumeUSD: 90,
        liquidityUSD: 90
    }, 
];
var DataToken = {
    exists: false,
    name: "Run",
    symbol: "Run",
    address: "0xc643e83587818202e0fff5ed96d10abbc8bb48e7",
    volumeUSD: 100,
    volumeUSDChange: 100,
    volumeUSDWeek: 100,
    txCount: 100,
    txCountAll: 100,
    liquidityToken: 100,
    liquidityUSD: 1000,
    liquidityUSDChange: 1000,
    priceUSD: 100,
    priceUSDChange: 10,
    priceUSDChangeWeek: 10
};
var DataPriceToken = [
    {
        close: 0.008103194697330061,
        high: 0.008103194697330061,
        low: 0.008116015943161697,
        open: 0.008116015943161697,
        time: 1670317200
    },
    {
        close: 0.008103194697330061,
        high: 0.008103194697330061,
        low: 0.008116015943161697,
        open: 0.008116015943161697,
        time: 1670320800
    },
    {
        close: 0.018116015943161697,
        high: 0.008103194697330061,
        low: 0.008116015943161697,
        open: 0.008116015943161697,
        time: 1670324400
    },
    {
        close: 0.018116015943161697,
        high: 0.018116015943161697,
        low: 0.008116015943161697,
        open: 0.008116015943161697,
        time: 1670328000
    },
    {
        close: 0.008103194697330061,
        high: 0.018116015943161697,
        low: 0.008116015943161697,
        open: 0.008116015943161697,
        time: 1670331600
    },
    {
        close: 0.008103194697330061,
        high: 0.008103194697330061,
        low: 0.008116015943161697,
        open: 0.018116015943161697,
        time: 1670335200
    },
    {
        close: 0.008103194697330061,
        high: 0.008103194697330061,
        low: 0.018116015943161697,
        open: 0.008116015943161697,
        time: 1670338800
    },
    {
        close: 0.008103194697330061,
        high: 0.008103194697330061,
        low: 0.008116015943161697,
        open: 0.008116015943161697,
        time: 1670342400
    },
    {
        close: 0.018116015943161697,
        high: 0.008103194697330061,
        low: 0.008116015943161697,
        open: 0.018116015943161697,
        time: 1670317200
    }, 
];

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Clear.js
var Clear = __webpack_require__(63343);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Edit.js
var Edit = __webpack_require__(77957);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 15 modules
var Tooltip = __webpack_require__(17163);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 7 modules
var IconButton = __webpack_require__(80331);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box_Box = __webpack_require__(85333);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(65528);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(80421);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowBack.tsx
var ArrowBack = __webpack_require__(69508);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowForward.tsx
var ArrowForward = __webpack_require__(16863);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(93293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(90452);
;// CONCATENATED MODULE: ./src/views/Info/Tokens/Modal/ModalDelete.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: red;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 600px) {\n    display: flex;\n    flex-direction: column;\n    width: 75%;\n    margin-bottom: 15rem;\n    border-radius: 30px;\n  }\n\n  @media screen and (min-width: 601px) and (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    margin-bottom: 15rem;\n    border-radius: 30px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var RefreshDelete = [];
var RefreshDeleteGlobal = /*#__PURE__*/ (0,react.createContext)(RefreshDelete);
var ModalDelete = function(param) {
    var onDismiss = param.onDismiss, onRefresh = param.onRefresh, ID = param.ID;
    var handleCancel = function handleCancel() {
        onDismiss();
    };
    var tokenAuth = localStorage.getItem("token");
    var ref = (0,react.useState)([]), posts = ref[0], setPosts = ref[1];
    var deletePost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return axios_default()["delete"]("https://dog-watcher-api.deltalabsjsc.com:4001/api/v1/admin/product/".concat(ID), {
                            headers: {
                                "Content-Type": "application/json",
                                token: "".concat(tokenAuth)
                            }
                        });
                    case 2:
                        onRefresh("Reset");
                        onDismiss();
                        RefreshDelete.push("Delete");
                        setPosts(posts.filter(function(post) {
                            return post.id !== ID;
                        }));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deletePost() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal, {
        title: "Delete",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFlex, {
            width: "20vw",
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "space-around",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton, {
                        onClick: deletePost,
                        children: "Delete"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleCancel,
                        children: "Cancel"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Modal_ModalDelete = (ModalDelete);
var CustomButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-f1b8f4e8-0"
})(_templateObject());
var CustomModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-f1b8f4e8-1"
})(_templateObject1());
var CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f1b8f4e8-2"
})(_templateObject2());

// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(5324);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/InputGroup.tsx
var InputGroup = __webpack_require__(28653);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js
var core_esm = __webpack_require__(77044);
;// CONCATENATED MODULE: ./src/views/Info/Tokens/Modal/ModalUpdate.tsx



function ModalUpdate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: 'primary';\n  margin-left: 2rem;\n"
    ]);
    ModalUpdate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalUpdate_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10rem;\n  width: 100%;\n  height: 100px;\n  padding-top: 10rem;\n"
    ]);
    ModalUpdate_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalUpdate_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 600px) {\n    width: 98%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  @media screen and (min-width: 601px) and (max-width: 768px) {\n    width: 600px;\n  }\n  @media screen and (min-width: 769px) and (max-width: 1024px) {\n    width: 700px;\n    margin-top: 1rem;\n  }\n  @media screen and (min-width: 1025px) and (max-width: 1440px) {\n    width: 700px;\n    margin-top: 1rem;\n  }\n  @media screen and (min-width: 1441px) and (max-width: 2556px) {\n    width: 700px;\n    margin-top: 1rem;\n  }\n"
    ]);
    ModalUpdate_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 600px) {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-left: -30px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 600px) {\n    display: flex;\n    flex-direction: column;\n    width: 95%;\n    height: 80%;\n    margin-bottom: 5rem;\n    border-radius: 30px;\n  }\n\n  @media screen and (min-width: 601px) and (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    width: 90%;\n    height: 70%;\n    margin-bottom: 5rem;\n    border-radius: 30px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var ModalUpdate = function(param) {
    var onDismiss = param.onDismiss, onRefresh = param.onRefresh, id = param.id;
    var ref = (0,react.useState)(""), name = ref[0], setName = ref[1];
    var ref1 = (0,react.useState)(""), address = ref1[0], setAddress = ref1[1];
    var ref2 = (0,react.useState)(1), limit = ref2[0], setLimit = ref2[1];
    var ref3 = (0,react.useState)([]), posts = ref3[0], setPosts = ref3[1];
    var ref4 = (0,react.useState)(""), walletInfo = ref4[0], setWalletInfo = ref4[1];
    var tokenAuth = localStorage.getItem("token");
    (0,react.useEffect)(function() {
        config/* getSingleProductClient.get */.q8.get("".concat(id)).then(function(response) {
            if (walletInfo === "") {
                setWalletInfo(response.data.product);
                setName(response.data.product.name);
                setAddress(response.data.product.address);
                setLimit(response.data.product.limit);
            }
        });
    }, [
        walletInfo
    ]);
    var updatePost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return axios_default().put("https://dog-watcher-api.deltalabsjsc.com:4001/api/v1/admin/product/".concat(id), {
                            name: name,
                            address: address,
                            limit: limit
                        }, {
                            headers: {
                                "Content-Type": "application/json",
                                token: "".concat(tokenAuth)
                            }
                        });
                    case 2:
                        onRefresh("Reset");
                        onDismiss();
                        setPosts(posts.filter(function(post) {
                            return post !== id;
                        }));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updatePost() {
            return _ref.apply(this, arguments);
        };
    }();
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref5 = (0,react.useState)(0), check = ref5[0], setCheck = ref5[1];
    var checkValidate = function(addressV) {
        if (!/^(0x)?[0-9a-f]{40}$/i.test(addressV)) {
            setCheck(1);
        } else if (addressV === account) {
            setCheck(2);
        } else {
            setCheck(0);
        }
    };
    var handleInputChangeAddress = function(e) {
        var value = e.target.value;
        setAddress(value);
        checkValidate(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUpdate_CustomModal, {
        title: "Edit Team Wallet",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalUpdate_CustomFlex, {
            width: "35vw",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomFlexInput, {
                            mt: "2rem",
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexInput, {
                                    width: "10%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "primary",
                                        children: "Name: "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexInput, {
                                    width: "62%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputGroup, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            color: "primary",
                                            value: name,
                                            onChange: function(e) {
                                                return setName(e.target.value);
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomFlexInput, {
                            mt: "2rem",
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexInput, {
                                    width: "10%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "primary",
                                        children: "Address: "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexInput, {
                                    width: "62%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputGroup, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            color: "primary",
                                            value: address,
                                            onChange: handleInputChangeAddress
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomFlexInput, {
                            mt: "2rem",
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexInput, {
                                    width: "10%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "primary",
                                        children: "Limit: "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexInput, {
                                    width: "62%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInputGroup, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            color: "primary",
                                            value: limit,
                                            onChange: function(e) {
                                                return setLimit(parseFloat(e.target.value));
                                            }
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    mt: "2rem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: updatePost,
                        disabled: Number.isNaN(limit) !== false || limit <= 0 || name === "" || address === "" || check !== 0,
                        children: "Update"
                    })
                }),
                check === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    marginTop: "1rem",
                    width: "100%",
                    textAlign: "center",
                    children: "Địa chỉ nhận đang l\xe0 v\xed của bạn"
                }),
                check === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    marginTop: "1rem",
                    width: "100%",
                    textAlign: "center",
                    children: "Địa chỉ v\xed kh\xf4ng đ\xfang"
                }),
                name === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    marginTop: "1rem",
                    width: "100%",
                    textAlign: "center",
                    children: "T\xean v\xed trống"
                })
            ]
        })
    });
};
/* harmony default export */ var Modal_ModalUpdate = (ModalUpdate);
var CustomInputGroup = (0,styled_components_browser_esm/* default */.ZP)(InputGroup/* default */.Z).withConfig({
    componentId: "sc-5f8f581b-0"
})(ModalUpdate_templateObject());
var ModalUpdate_CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5f8f581b-1"
})(ModalUpdate_templateObject1());
var CustomFlexInput = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5f8f581b-2"
})(ModalUpdate_templateObject2());
var FlexInput = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5f8f581b-3"
})(_templateObject3());
var ModalUpdate_CustomModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-5f8f581b-4"
})(_templateObject4());

// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(41144);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
;// CONCATENATED MODULE: ./src/views/Info/abis/ERC20abi.json
var ERC20abi_namespaceObject = JSON.parse('[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address[]","name":"addresses","type":"address[]"}],"name":"AddBlacklistEvent","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address[]","name":"addresses","type":"address[]"}],"name":"RemoveBlacklistEvent","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"role","type":"bytes32"},{"indexed":true,"internalType":"bytes32","name":"previousAdminRole","type":"bytes32"},{"indexed":true,"internalType":"bytes32","name":"newAdminRole","type":"bytes32"}],"name":"RoleAdminChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"role","type":"bytes32"},{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"sender","type":"address"}],"name":"RoleGranted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"role","type":"bytes32"},{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"sender","type":"address"}],"name":"RoleRevoked","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"id","type":"uint256"}],"name":"Snapshot","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"inputs":[],"name":"DEFAULT_ADMIN_ROLE","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"PAUSER_ROLE","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"SNAPSHOT_ROLE","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"_blacklistAddresses","type":"address[]"}],"name":"addBlacklist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"snapshotId","type":"uint256"}],"name":"balanceOfAt","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burnFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"}],"name":"getRoleAdmin","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"grantRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"hasRole","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"isBlacklist","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"_blacklistAddresses","type":"address[]"}],"name":"removeBlacklist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"renounceRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"revokeRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"snapshot","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"snapshotId","type":"uint256"}],"name":"totalSupplyAt","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"unpause","outputs":[],"stateMutability":"nonpayable","type":"function"}]');
;// CONCATENATED MODULE: ./src/views/Info/hooks/useTotalSupply.ts





var FetchTokenBalance = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(addresses) {
        var calls, result, balances;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    calls = [];
                    addresses.forEach(function(teams) {
                        calls.push({
                            address: "0xc643e83587818202e0fff5ed96d10abbc8bb48e7",
                            name: "balanceOf",
                            params: [
                                teams
                            ]
                        });
                    });
                    _ctx.next = 5;
                    return (0,multicall/* default */.Z)(ERC20abi_namespaceObject, calls);
                case 5:
                    result = _ctx.sent;
                    balances = [];
                    result.forEach(function(balance) {
                        balances.push(Number(new bignumber/* default */.Z(balance).toJSON()) / 1e18);
                    });
                    return _ctx.abrupt("return", {
                        tokenBalanceVal: balances
                    });
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        tokenBalanceVal: []
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function FetchTokenBalance(addresses) {
        return _ref.apply(this, arguments);
    };
}();
var fetchTotalSuppy = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var calls, result, resultNumber;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    calls = [
                        {
                            address: "0xc643e83587818202e0fff5ed96d10abbc8bb48e7",
                            name: "totalSupply",
                            params: []
                        }, 
                    ];
                    _ctx.next = 4;
                    return (0,multicall/* default */.Z)(ERC20abi_namespaceObject, calls);
                case 4:
                    result = _ctx.sent;
                    resultNumber = new bignumber/* default */.Z(result.toString()).toNumber() / 1e18;
                    return _ctx.abrupt("return", {
                        totalSupply: resultNumber
                    });
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        totalSupply: 0
                    });
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function fetchTotalSuppy() {
        return _ref.apply(this, arguments);
    };
}();
var FetchCirculatingSupply = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(addresses) {
        var calls, result, balances, totalBalance, totalSupplyCalls, totalSupplyResult, resultNumber, circulatingSupplyValue;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    calls = [];
                    addresses.forEach(function(teams) {
                        calls.push({
                            address: "0xc643e83587818202e0fff5ed96d10abbc8bb48e7",
                            name: "balanceOf",
                            params: [
                                teams
                            ]
                        });
                    });
                    _ctx.next = 5;
                    return (0,multicall/* default */.Z)(ERC20abi_namespaceObject, calls);
                case 5:
                    result = _ctx.sent;
                    balances = [];
                    result.forEach(function(balance) {
                        balances.push(Number(new bignumber/* default */.Z(balance).toJSON()) / 1e18);
                    });
                    totalBalance = 0;
                    balances.forEach(function(balance) {
                        totalBalance += balance;
                    });
                    totalSupplyCalls = [
                        {
                            address: "0xc643e83587818202e0fff5ed96d10abbc8bb48e7",
                            name: "totalSupply",
                            params: []
                        }, 
                    ];
                    _ctx.next = 13;
                    return (0,multicall/* default */.Z)(ERC20abi_namespaceObject, totalSupplyCalls);
                case 13:
                    totalSupplyResult = _ctx.sent;
                    resultNumber = new bignumber/* default */.Z(totalSupplyResult.toString()).toNumber() / 1e18;
                    circulatingSupplyValue = resultNumber - totalBalance;
                    return _ctx.abrupt("return", {
                        circulatingSupply: circulatingSupplyValue
                    });
                case 19:
                    _ctx.prev = 19;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        circulatingSupply: 0
                    });
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                19
            ]
        ]);
    }));
    return function FetchCirculatingSupply(addresses) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/views/Info/components/InfoTables/shared.tsx
var shared = __webpack_require__(58910);
;// CONCATENATED MODULE: ./src/views/Info/components/InfoTables/TeamWalletTable.tsx




function TeamWalletTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-gap: 1em;\n  align-items: center;\n  grid-template-columns: 20px 5fr 5fr 0fr 10fr;\n  padding: 0 24px;\n  overflow: hidden;\n  position: relative;\n"
    ]);
    TeamWalletTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TeamWalletTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 600px) {\n    display: none;\n  }\n"
    ]);
    TeamWalletTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TeamWalletTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 350px;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 350px;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 350px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 250px;\n  }\n  @media screen and (max-width: 900px) {\n    width: 230px;\n  }\n  @media screen and (max-width: 600px) {\n    width: 220px;\n  }\n  @media screen and (max-width: 400px) {\n    width: 200px;\n  }\n  @media screen and (max-width: 340px) {\n    width: 100px;\n  }\n  @media screen and (max-width: 319px) {\n    display: none;\n  }\n"
    ]);
    TeamWalletTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TeamWalletTable_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 350px;\n    margin-left: 3rem;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 350px;\n    margin-left: 3rem;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 350px;\n    margin-left: 1rem;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 250px;\n    margin-left: 3rem;\n  }\n  @media screen and (max-width: 900px) {\n    width: 220px;\n    margin-left: 0rem;\n  }\n  @media screen and (max-width: 840px) {\n    width: 220px;\n  }\n  @media screen and (max-width: 600px) {\n    display: none;\n  }\n"
    ]);
    TeamWalletTable_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TeamWalletTable_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 70px;\n    margin-left: -2rem;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 70px;\n    margin-left: -2rem;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 70px;\n    margin-left: -2rem;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 70px;\n    margin-left: 2rem;\n  }\n  @media screen and (max-width: 900px) {\n    width: 70px;\n    position: absolute;\n    right: 80px;\n  }\n  @media screen and (max-width: 600px) {\n    width: 70px;\n    position: absolute;\n    right: 40px;\n  }\n  @media screen and (max-width: 400px) {\n    width: 70px;\n    position: absolute;\n    right: 25px;\n  }\n"
    ]);
    TeamWalletTable_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 80px;\n    position: absolute;\n    right: 70px;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 80px;\n    position: absolute;\n    right: 70px;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 80px;\n    position: absolute;\n    right: 60px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 80px;\n    position: absolute;\n    right: 50px;\n  }\n  @media screen and (max-width: 900px) {\n    width: 80px;\n    display: none;\n  }\n  @media screen and (max-width: 600px) {\n    width: 10vw;\n    margin-left: -10vw;\n    display: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 80px;\n    position: absolute;\n    right: 50px;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 80px;\n    position: absolute;\n    right: 50px;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 80px;\n    position: absolute;\n    right: 40px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 80px;\n    position: absolute;\n    right: 35px;\n  }\n  @media screen and (max-width: 900px) {\n    width: 80px;\n    margin-left: 20px;\n    display: none;\n  }\n  @media screen and (max-width: 600px) {\n    width: 10vw;\n    margin-left: -5vw;\n    display: none;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 600px) {\n    display: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 350px;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 350px;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 350px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 250px;\n  }\n  @media screen and (max-width: 900px) {\n    width: 230px;\n  }\n  @media screen and (max-width: 600px) {\n    width: 220px;\n  }\n  @media screen and (max-width: 400px) {\n    width: 200px;\n  }\n  @media screen and (max-width: 340px) {\n    width: 100px;\n  }\n  @media screen and (max-width: 319px) {\n    display: none;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 350px;\n    margin-left: 5rem;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 350px;\n    margin-left: 5rem;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 350px;\n    margin-left: 5rem;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 250px;\n    margin-left: 6rem;\n  }\n  @media screen and (max-width: 900px) {\n    width: 220px;\n    margin-left: 0rem;\n  }\n  @media screen and (max-width: 840px) {\n    width: 220px;\n    margin-left: 0rem;\n  }\n\n  @media screen and (max-width: 700px) {\n    display: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 70px;\n    margin-left: 3rem;\n    position: absolute;\n    right: 70px;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 70px;\n    margin-left: 3rem;\n    position: absolute;\n    right: 70px;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 70px;\n    margin-left: 3rem;\n    position: absolute;\n    right: 60px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 70px;\n    position: absolute;\n    right: 40px;\n  }\n  @media screen and (max-width: 900px) {\n    width: 70px;\n    position: absolute;\n    right: 85px;\n  }\n  @media screen and (max-width: 600px) {\n    width: 70px;\n    position: absolute;\n    right: 35px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


















var ResponsiveGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c9432c8e-0"
})(TeamWalletTable_templateObject());
var SORT_FIELD = {
    volumeUSD: "volumeUSD",
    liquidityUSD: "liquidityUSD",
    volumeUSDWeek: "volumeUSDWeek",
    lpFees24h: "lpFees24h",
    lpApr7d: "lpApr7d"
};
var LoadingRow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveGrid, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
        ]
    });
};
var TableLoader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {})
        ]
    });
};
var Refresh = [];
var DataRow = function() {
    var sAccount = function sAccount(dataAddress) {
        if (dataAddress) {
            return "".concat(dataAddress.substring(0, 8), "...").concat(dataAddress.substring(dataAddress.length - 8));
        }
        return "";
    };
    var ref = (0,react.useState)([]), walletInfo = ref[0], setWalletInfo = ref[1];
    var ref1 = (0,react.useState)([]), walletAddresses = ref1[0], setWalletAddresses = ref1[1];
    var ref2 = (0,react.useState)({
        tokenBalanceVal: [
            0
        ]
    }), tokenBalances = ref2[0], setTokenBalances = ref2[1];
    var tokenAuth = localStorage.getItem("token");
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    (0,react.useEffect)(function() {
        var getSaleItems = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var result;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            if (!(walletAddresses.length > 0)) {
                                _ctx.next = 6;
                                break;
                            }
                            _ctx.next = 4;
                            return FetchTokenBalance(walletAddresses);
                        case 4:
                            result = _ctx.sent;
                            setTokenBalances(result);
                        case 6:
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return function getSaleItems() {
                return _ref.apply(this, arguments);
            };
        }();
        getSaleItems();
    }, [
        walletAddresses
    ]);
    var appContext = (0,react.useContext)(Menu/* RefreshCreateGlobal */.t);
    (0,react.useEffect)(function() {
        config/* getProductClient.get */.GI.get("").then(function(response) {
            setWalletInfo(response.data.products);
            var addresses = response.data.products.map(function(wallet) {
                return wallet.address;
            });
            setWalletAddresses(addresses);
        });
    }, [
        Refresh.length,
        appContext.length
    ]);
    var ref3 = (0,react.useState)(0), idDelete = ref3[0], setIdDelete = ref3[1];
    var ref4 = (0,react.useState)(0), idUpdate = ref4[0], setUpdate = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalDelete, {
        ID: idDelete,
        onRefresh: function(newValue) {
            return Refresh.push(newValue);
        }
    })), 1), handleClickDel = ref5[0];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalUpdate, {
        id: idUpdate,
        onRefresh: function(newValue) {
            return Refresh.push(newValue);
        }
    })), 1), handleClickUpdate = ref6[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: walletInfo.map(function(data, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveGrid, {
                children: [
                    tokenAuth !== null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexID, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    children: index + 1
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexName, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: (0,utils/* getBscScanLink */.s6)(data.address, "address", chainId),
                                    external: true,
                                    children: data.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "hidden",
                                value: data._id
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexAddress, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: (0,utils/* getBscScanLink */.s6)(data.address, "address", chainId),
                                    external: true,
                                    children: sAccount(data.address)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBalance, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    children: (0,formatInfoNumbers/* formatAmount */.d)(Math.round(tokenBalances.tokenBalanceVal[index]), {
                                        isInteger: true
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexIDV2, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: index + 1
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexNameV2, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: (0,utils/* getBscScanLink */.s6)(data.address, "address", chainId),
                                    external: true,
                                    children: data.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "hidden",
                                value: data._id
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexAddressV2, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: (0,utils/* getBscScanLink */.s6)(data.address, "address", chainId),
                                    external: true,
                                    children: sAccount(data.address)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBalanceV2, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    children: (0,formatInfoNumbers/* formatAmount */.d)(Math.round(tokenBalances.tokenBalanceVal[index]), {
                                        isInteger: true
                                    })
                                })
                            })
                        ]
                    }),
                    tokenAuth !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexAction, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "center",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        placement: "top",
                                        title: "Update",
                                        onClick: handleClickUpdate,
                                        onClickCapture: function() {
                                            return setUpdate(data._id);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            color: "primary",
                                            "aria-label": "delete",
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Edit/* default */.Z, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        placement: "top",
                                        title: "Delete",
                                        onClick: handleClickDel,
                                        onClickCapture: function() {
                                            return setIdDelete(data._id);
                                        },
                                        sx: {
                                            marginLeft: "-1rem"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            color: "primary",
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {})
                                        })
                                    })
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            });
        })
    });
};
var TeamWalletTable = function(param) {
    var loading = param.loading;
    var router = (0,next_router.useRouter)();
    // for sorting
    var ref = (0,react.useState)(SORT_FIELD.volumeUSD), sortField = ref[0], setSortField = ref[1];
    var ref1 = (0,react.useState)(true), sortDirection = ref1[0], setSortDirection = ref1[1];
    var t = (0,src/* useTranslation */.$G)().t;
    // pagination
    var ref2 = (0,react.useState)(1), page = ref2[0], setPage = ref2[1];
    var ref3 = (0,react.useState)(1), maxPage = ref3[0], setMaxPage = ref3[1];
    var handleSort = (0,react.useCallback)(function(newField) {
        setSortField(newField);
        setSortDirection(sortField !== newField ? true : !sortDirection);
    }, [
        sortDirection,
        sortField
    ]);
    var arrow = (0,react.useCallback)(function(field) {
        var directionArrow = !sortDirection ? "↑" : "↓";
        return sortField === field ? directionArrow : "";
    }, [
        sortDirection,
        sortField
    ]);
    var ref4 = (0,react.useState)([]), walletInfo = ref4[0], setWalletInfo = ref4[1];
    var appContext = (0,react.useContext)(Menu/* RefreshCreateGlobal */.t);
    (0,react.useEffect)(function() {
        config/* getProductClient.get */.GI.get("").then(function(response) {
            setWalletInfo(response.data.products);
        });
    }, [
        Refresh.length,
        appContext.length
    ]);
    var tokenAuth = localStorage.getItem("token");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* TableWrapper */.y6, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveGrid, {
                children: tokenAuth !== null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexID, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                children: "#"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexName, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Name")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexAddress, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Address")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBalance, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Balance")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexActionTitle, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Action")
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexIDV2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                children: "#"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexNameV2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Name")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexAddressV2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Address")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBalanceV2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Balance")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexActionTitleV2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Action")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* Break */.SS, {}),
            walletInfo.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataRow, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* Break */.SS, {}),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* PageButtons */.Ob, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* Arrow */.Eh, {
                                onClick: function() {
                                    setPage(page === 1 ? page : page - 1);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                                    color: page === 1 ? "textDisabled" : "primary"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: t("Page %page% of %maxPage%", {
                                    page: page,
                                    maxPage: maxPage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* Arrow */.Eh, {
                                onClick: function() {
                                    setPage(page === maxPage ? page : page + 1);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                    color: page === maxPage ? "textDisabled" : "primary"
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableLoader, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var InfoTables_TeamWalletTable = (TeamWalletTable);
var FlexID = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c9432c8e-1"
})(TeamWalletTable_templateObject1());
var FlexName = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c9432c8e-2"
})(TeamWalletTable_templateObject2());
var FlexAddress = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c9432c8e-3"
})(TeamWalletTable_templateObject3());
var FlexBalance = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c9432c8e-4"
})(TeamWalletTable_templateObject4());
var FlexAction = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c9432c8e-5"
})(_templateObject5());
var FlexActionTitle = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c9432c8e-6"
})(_templateObject6());
// No login
var FlexIDV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c9432c8e-7"
})(_templateObject7());
var FlexNameV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c9432c8e-8"
})(_templateObject8());
var FlexAddressV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c9432c8e-9"
})(_templateObject9());
var FlexBalanceV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c9432c8e-10"
})(_templateObject10());
var FlexActionTitleV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c9432c8e-11"
})(_templateObject11());

// EXTERNAL MODULE: ./src/components/Select/Select.tsx
var Select = __webpack_require__(37370);
// EXTERNAL MODULE: ./src/state/info/hooks.ts + 6 modules
var hooks = __webpack_require__(53985);
;// CONCATENATED MODULE: ./src/views/Info/Tokens/Modal/ModalTrackingDelete.tsx



function ModalTrackingDelete_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: red;\n"
    ]);
    ModalTrackingDelete_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalTrackingDelete_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 600px) {\n    display: flex;\n    flex-direction: column;\n    width: 75%;\n    margin-bottom: 15rem;\n    border-radius: 30px;\n  }\n\n  @media screen and (min-width: 601px) and (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    width: 50%;\n    margin-bottom: 15rem;\n    border-radius: 30px;\n  }\n"
    ]);
    ModalTrackingDelete_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalTrackingDelete_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    ModalTrackingDelete_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var ModalTrackingDelete_RefreshDelete = [];
var RefreshTrackingDeleteGlobal = /*#__PURE__*/ (/* unused pure expression or super */ null && (createContext(ModalTrackingDelete_RefreshDelete)));
var ModalTrackingDelete = function(param) {
    var onDismiss = param.onDismiss, onRefresh = param.onRefresh, ID = param.ID;
    var handleCancel = function handleCancel() {
        onDismiss();
    };
    var tokenAuth = localStorage.getItem("token");
    var ref = (0,react.useState)([]), posts = ref[0], setPosts = ref[1];
    var deletePost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return axios_default()["delete"]("https://dog-watcher-api.deltalabsjsc.com:4001/api/v1/admin/tracking/".concat(ID), {
                            headers: {
                                "Content-Type": "application/json",
                                token: "".concat(tokenAuth)
                            }
                        });
                    case 2:
                        onRefresh("Reset");
                        onDismiss();
                        ModalTrackingDelete_RefreshDelete.push("Delete");
                        setPosts(posts.filter(function(post) {
                            return post.id !== ID;
                        }));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deletePost() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingDelete_CustomModal, {
        title: "Delete",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingDelete_CustomFlex, {
            width: "20vw",
            justifyContent: "center",
            alignItems: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "space-around",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingDelete_CustomButton, {
                        onClick: deletePost,
                        children: "Delete"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleCancel,
                        children: "Cancel"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Modal_ModalTrackingDelete = (ModalTrackingDelete);
var ModalTrackingDelete_CustomButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-e9819431-0"
})(ModalTrackingDelete_templateObject());
var ModalTrackingDelete_CustomModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-e9819431-1"
})(ModalTrackingDelete_templateObject1());
var ModalTrackingDelete_CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e9819431-2"
})(ModalTrackingDelete_templateObject2());

;// CONCATENATED MODULE: ./src/views/Info/Tokens/Modal/ModalTrackingUpdate.tsx



function ModalTrackingUpdate_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: 'primary';\n  margin-left: 2rem;\n"
    ]);
    ModalTrackingUpdate_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalTrackingUpdate_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 10rem;\n  width: 100%;\n  margin-top: 0rem;\n"
    ]);
    ModalTrackingUpdate_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalTrackingUpdate_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 600px) {\n    width: 98%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  @media screen and (min-width: 601px) and (max-width: 768px) {\n    width: 600px;\n  }\n  @media screen and (min-width: 769px) and (max-width: 1024px) {\n    width: 700px;\n    margin-top: 1rem;\n  }\n  @media screen and (min-width: 1025px) and (max-width: 1440px) {\n    width: 700px;\n    margin-top: 1rem;\n  }\n  @media screen and (min-width: 1441px) and (max-width: 2556px) {\n    width: 700px;\n    margin-top: 1rem;\n  }\n"
    ]);
    ModalTrackingUpdate_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalTrackingUpdate_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 600px) {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-left: -30px;\n  }\n"
    ]);
    ModalTrackingUpdate_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalTrackingUpdate_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: 3rem;\n  height: 70%;\n  @media screen and (max-width: 600px) {\n    display: flex;\n    flex-direction: column;\n    width: 95%;\n    height: 80%;\n    margin-bottom: 5rem;\n    border-radius: 30px;\n  }\n  @media screen and (min-width: 601px) and (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    width: 90%;\n    height: 70%;\n    margin-bottom: 5rem;\n    border-radius: 30px;\n  }\n"
    ]);
    ModalTrackingUpdate_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ModalTrackingUpdate_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 20%;\n  @media screen and (max-width: 600px) {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-left: -20px;\n  }\n"
    ]);
    ModalTrackingUpdate_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var ModalTrackingUpdate = function(param) {
    var onDismiss = param.onDismiss, onRefresh = param.onRefresh, id = param.id;
    var ref = (0,react.useState)(""), name = ref[0], setName = ref[1];
    var ref1 = (0,react.useState)(""), address = ref1[0], setAddress = ref1[1];
    var ref2 = (0,react.useState)(""), stakeToken = ref2[0], setStakeToken = ref2[1];
    var ref3 = (0,react.useState)(""), rewardToken = ref3[0], setRewardToken = ref3[1];
    var ref4 = (0,react.useState)(1), limit = ref4[0], setLimit = ref4[1];
    var ref5 = (0,react.useState)([]), posts = ref5[0], setPosts = ref5[1];
    var ref6 = (0,react.useState)(""), walletInfo = ref6[0], setWalletInfo = ref6[1];
    var tokenAuth = localStorage.getItem("token");
    (0,react.useEffect)(function() {
        config/* getSingleTrackingClient.get */.rp.get("".concat(id)).then(function(response) {
            if (walletInfo === "") {
                setWalletInfo(response.data.tracking);
                setName(response.data.tracking.name);
                setAddress(response.data.tracking.address);
                setLimit(response.data.tracking.limit);
                setStakeToken(response.data.tracking.stakeToken);
                setRewardToken(response.data.tracking.rewardToken);
            }
        });
    }, [
        walletInfo
    ]);
    var updatePost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return axios_default().put("https://dog-watcher-api.deltalabsjsc.com:4001/api/v1/admin/tracking/".concat(id), {
                            name: name,
                            address: address,
                            limit: limit,
                            stakeToken: stakeToken,
                            rewardToken: rewardToken
                        }, {
                            headers: {
                                "Content-Type": "application/json",
                                token: "".concat(tokenAuth)
                            }
                        });
                    case 2:
                        onRefresh("Reset");
                        onDismiss();
                        setPosts(posts.filter(function(post) {
                            return post !== id;
                        }));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function updatePost() {
            return _ref.apply(this, arguments);
        };
    }();
    var account = (0,core_esm/* useWeb3React */.Ge)().account;
    var ref7 = (0,react.useState)(0), check = ref7[0], setCheck = ref7[1];
    var checkValidate = function(addressV) {
        if (!/^(0x)?[0-9a-f]{40}$/i.test(addressV)) {
            setCheck(1);
        } else if (addressV === account) {
            setCheck(2);
        } else {
            setCheck(0);
        }
    };
    var handleInputChangeAddress = function(e) {
        var value = e.target.value;
        setAddress(value);
        checkValidate(value);
    };
    var handleInputChangeStakeToken = function(e) {
        var value = e.target.value;
        setStakeToken(value);
        checkValidate(value);
    };
    var handleInputChangeRewardToken = function(e) {
        var value = e.target.value;
        setRewardToken(value);
        checkValidate(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingUpdate_CustomModal, {
        title: "Edit Tracking Wallet",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalTrackingUpdate_CustomFlex, {
            width: "35vw",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    width: "100%",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalTrackingUpdate_CustomFlexInput, {
                            mt: "2rem",
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexInputText, {
                                    width: "10%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "primary",
                                        children: "Name: "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingUpdate_FlexInput, {
                                    width: "62%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingUpdate_CustomInputGroup, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            color: "primary",
                                            value: name,
                                            onChange: function(e) {
                                                return setName(e.target.value);
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalTrackingUpdate_CustomFlexInput, {
                            mt: "2rem",
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexInputText, {
                                    width: "10%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "primary",
                                        children: "Address: "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingUpdate_FlexInput, {
                                    width: "62%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingUpdate_CustomInputGroup, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            color: "primary",
                                            value: address,
                                            onChange: handleInputChangeAddress
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalTrackingUpdate_CustomFlexInput, {
                            mt: "2rem",
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexInputText, {
                                    width: "10%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "primary",
                                        children: "Limit: "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingUpdate_FlexInput, {
                                    width: "62%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingUpdate_CustomInputGroup, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            color: "primary",
                                            value: limit,
                                            onChange: function(e) {
                                                return setLimit(parseFloat(e.target.value));
                                            }
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalTrackingUpdate_CustomFlexInput, {
                            mt: "2rem",
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexInputText, {
                                    width: "10%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "primary",
                                        children: "Stake Token: "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingUpdate_FlexInput, {
                                    width: "62%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingUpdate_CustomInputGroup, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            color: "primary",
                                            value: stakeToken,
                                            onChange: handleInputChangeStakeToken
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalTrackingUpdate_CustomFlexInput, {
                            mt: "2rem",
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexInputText, {
                                    width: "10%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "primary",
                                        children: "Reward Token: "
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingUpdate_FlexInput, {
                                    width: "62%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTrackingUpdate_CustomInputGroup, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            color: "primary",
                                            value: rewardToken,
                                            onChange: handleInputChangeRewardToken
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    mt: "2rem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: updatePost,
                        disabled: Number.isNaN(limit) !== false || limit <= 0 || name === "" || address === "" || check !== 0 || stakeToken === "" || rewardToken === "",
                        children: "Update"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    children: [
                        check === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            marginTop: "1rem",
                            width: "100%",
                            textAlign: "center",
                            children: "Địa chỉ nhận đang l\xe0 v\xed của bạn"
                        }),
                        check === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            marginTop: "1rem",
                            width: "100%",
                            textAlign: "center",
                            children: "Địa chỉ v\xed kh\xf4ng đ\xfang"
                        }),
                        name === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            marginBottom: "2rem",
                            marginTop: "1rem",
                            width: "100%",
                            textAlign: "center",
                            children: "T\xean v\xed trống"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Modal_ModalTrackingUpdate = (ModalTrackingUpdate);
var ModalTrackingUpdate_CustomInputGroup = (0,styled_components_browser_esm/* default */.ZP)(InputGroup/* default */.Z).withConfig({
    componentId: "sc-e7385228-0"
})(ModalTrackingUpdate_templateObject());
var ModalTrackingUpdate_CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e7385228-1"
})(ModalTrackingUpdate_templateObject1());
var ModalTrackingUpdate_CustomFlexInput = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e7385228-2"
})(ModalTrackingUpdate_templateObject2());
var ModalTrackingUpdate_FlexInput = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e7385228-3"
})(ModalTrackingUpdate_templateObject3());
var ModalTrackingUpdate_CustomModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).withConfig({
    componentId: "sc-e7385228-4"
})(ModalTrackingUpdate_templateObject4());
var FlexInputText = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-e7385228-5"
})(ModalTrackingUpdate_templateObject5());

;// CONCATENATED MODULE: ./src/views/Info/hooks/useTokenBalance.ts





var useTokenBalance_FetchTokenBalance = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(addresses) {
        var calls, result, balances;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    calls = [];
                    addresses.forEach(function(teams) {
                        calls.push({
                            address: "0xc643e83587818202e0fff5ed96d10abbc8bb48e7",
                            name: "balanceOf",
                            params: [
                                teams
                            ]
                        });
                    });
                    _ctx.next = 5;
                    return (0,multicall/* default */.Z)(ERC20abi_namespaceObject, calls);
                case 5:
                    result = _ctx.sent;
                    balances = [];
                    result.forEach(function(balance) {
                        balances.push(Number(new bignumber/* default */.Z(balance).toJSON()) / 1e18);
                    });
                    return _ctx.abrupt("return", {
                        tokenBalanceVal: balances
                    });
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        tokenBalanceVal: []
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function FetchTokenBalance(addresses) {
        return _ref.apply(this, arguments);
    };
}();
var FetchStakeBalance = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(addresses, token) {
        var calls, i, result, balances;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    calls = [];
                    for(i = 0; i < addresses.length; i++){
                        calls.push({
                            address: token[i],
                            name: "balanceOf",
                            params: [
                                addresses[i]
                            ]
                        });
                    }
                    _ctx.next = 5;
                    return (0,multicall/* default */.Z)(ERC20abi_namespaceObject, calls);
                case 5:
                    result = _ctx.sent;
                    balances = [];
                    result.forEach(function(balance) {
                        balances.push(Number(new bignumber/* default */.Z(balance).toJSON()) / 1e18);
                    });
                    return _ctx.abrupt("return", {
                        tokenBalanceVal: balances
                    });
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        tokenBalanceVal: []
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function FetchStakeBalance(addresses, token) {
        return _ref.apply(this, arguments);
    };
}();
var FetchRewardBalance = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(addresses, token) {
        var calls, i, result, balances;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    calls = [];
                    for(i = 0; i < addresses.length; i++){
                        calls.push({
                            address: token[i],
                            name: "balanceOf",
                            params: [
                                addresses[i]
                            ]
                        });
                    }
                    _ctx.next = 5;
                    return (0,multicall/* default */.Z)(ERC20abi_namespaceObject, calls);
                case 5:
                    result = _ctx.sent;
                    balances = [];
                    result.forEach(function(balance) {
                        balances.push(Number(new bignumber/* default */.Z(balance).toJSON()) / 1e18);
                    });
                    return _ctx.abrupt("return", {
                        tokenBalanceVal: balances
                    });
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log(_ctx.t0);
                    return _ctx.abrupt("return", {
                        tokenBalanceVal: []
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                11
            ]
        ]);
    }));
    return function FetchRewardBalance(addresses, token) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/views/Info/components/InfoTables/TrackingWalletTable.tsx




function TrackingWalletTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-gap: 1em;\n  align-items: center;\n  grid-template-columns: 20px 5fr 5fr 0fr 10fr;\n  padding: 0 24px;\n  position: relative;\n"
    ]);
    TrackingWalletTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TrackingWalletTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 350px;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 350px;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 350px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 250px;\n  }\n  @media screen and (max-width: 900px) {\n    width: 230px;\n  }\n  @media screen and (max-width: 600px) {\n    width: 220px;\n  }\n  @media screen and (max-width: 400px) {\n    width: 130px;\n  }\n  @media screen and (max-width: 340px) {\n    width: 70px;\n  }\n  @media screen and (max-width: 319px) {\n    display: none;\n  }\n"
    ]);
    TrackingWalletTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TrackingWalletTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  @media screen and (max-width: 600px) {\n    width: 75%;\n  }\n"
    ]);
    TrackingWalletTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TrackingWalletTable_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 150%;\n"
    ]);
    TrackingWalletTable_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TrackingWalletTable_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 600px) {\n    display: none;\n  }\n"
    ]);
    TrackingWalletTable_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TrackingWalletTable_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 350px;\n    margin-left: 5rem;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 350px;\n    margin-left: 3rem;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 350px;\n    margin-left: 2rem;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 220px;\n  }\n  @media screen and (max-width: 900px) {\n    width: 230px;\n    margin-left: 0rem;\n  }\n  @media screen and (max-width: 800px) {\n    width: 230px;\n    margin-left: -2rem;\n  }\n  @media screen and (max-width: 700px) {\n    display: none;\n  }\n"
    ]);
    TrackingWalletTable_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TrackingWalletTable_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 250px;\n    gap: 50px;\n    position: absolute;\n    right: 180px;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 250px;\n    gap: 50px;\n    position: absolute;\n    right: 180px;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 250px;\n    position: absolute;\n    right: 160px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 250px;\n    position: absolute;\n    right: 140px;\n  }\n  @media screen and (max-width: 900px) {\n    width: 230px;\n    position: absolute;\n    right: 0px;\n    gap: 10px;\n  }\n  @media screen and (max-width: 600px) {\n    width: 180px;\n    position: absolute;\n    right: -8px;\n    gap: 0px;\n  }\n  @media screen and (max-width: 319px) {\n    display: none;\n  }\n"
    ]);
    TrackingWalletTable_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function TrackingWalletTable_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 70px;\n    position: absolute;\n    right: 80px;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 70px;\n    position: absolute;\n    right: 80px;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 70px;\n    position: absolute;\n    right: 70px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 70px;\n    position: absolute;\n    right: 50px;\n  }\n  @media screen and (max-width: 900px) {\n    display: none;\n  }\n"
    ]);
    TrackingWalletTable_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function TrackingWalletTable_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 70px;\n    position: absolute;\n    right: 70px;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 70px;\n    position: absolute;\n    right: 70px;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 70px;\n    position: absolute;\n    right: 60px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 70px;\n    position: absolute;\n    right: 40px;\n  }\n  @media screen and (max-width: 900px) {\n    display: none;\n  }\n"
    ]);
    TrackingWalletTable_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function TrackingWalletTable_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 600px) {\n    display: none;\n  }\n"
    ]);
    TrackingWalletTable_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function TrackingWalletTable_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 250px;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 250px;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 250px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 200px;\n  }\n  @media screen and (max-width: 900px) {\n    width: 150px;\n  }\n  @media screen and (max-width: 600px) {\n    margin-left: -0.75rem;\n    width: 150px;\n  }\n  @media screen and (max-width: 400px) {\n    width: 130px;\n  }\n  @media screen and (max-width: 340px) {\n    width: 70px;\n  }\n  @media screen and (max-width: 319px) {\n    display: none;\n  }\n"
    ]);
    TrackingWalletTable_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function TrackingWalletTable_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 100px;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 100px;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 100px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 100px;\n  }\n  @media screen and (max-width: 900px) {\n    width: 90px;\n    margin-left: -1.75rem;\n  }\n  @media screen and (max-width: 600px) {\n    margin-left: -0.75rem;\n    display: none;\n    width: 100px;\n  }\n"
    ]);
    TrackingWalletTable_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 100px;\n    margin-left: -1.75rem;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 100px;\n    margin-left: -1.75rem;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 100px;\n    margin-left: -1.75rem;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 100px;\n    margin-left: -1.75rem;\n  }\n  @media screen and (max-width: 900px) {\n    width: 10px;\n    margin-left: -1.75rem;\n  }\n  @media screen and (max-width: 600px) {\n    margin-left: -0.75rem;\n    display: none;\n    width: 100px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 300px;\n    margin-left: -5rem;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 300px;\n    margin-left: -4rem;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 300px;\n    margin-left: -2rem;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 200px;\n    margin-left: -2rem;\n  }\n  @media screen and (max-width: 900px) {\n    width: 150px;\n    margin-left: 0rem;\n  }\n  @media screen and (max-width: 800px) {\n    width: 200px;\n    margin-left: -2rem;\n  }\n  @media screen and (max-width: 700px) {\n    display: none;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 150%;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (min-width: 2560px) {\n    width: 250px;\n    gap: 50px;\n    position: absolute;\n    right: 70px;\n  }\n  @media screen and (max-width: 2560px) {\n    width: 250px;\n    gap: 50px;\n    position: absolute;\n    right: 70px;\n  }\n  @media screen and (max-width: 1440px) {\n    width: 250px;\n    gap: 40px;\n    position: absolute;\n    right: 60px;\n  }\n  @media screen and (max-width: 1024px) {\n    width: 250px;\n    gap: 30px;\n    position: absolute;\n    right: 40px;\n  }\n  @media screen and (max-width: 900px) {\n    width: 230px;\n    gap: 30px;\n    position: absolute;\n    right: 0px;\n  }\n  @media screen and (max-width: 600px) {\n    width: 180px;\n    position: absolute;\n    right: -5px;\n    gap: 0px;\n  }\n  @media screen and (max-width: 319px) {\n    display: none;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media screen and (max-width: 600px) {\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}





















var TrackingWalletTable_ResponsiveGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ae8eb6de-0"
})(TrackingWalletTable_templateObject());
var TrackingWalletTable_SORT_FIELD = {
    volumeUSD: "volumeUSD",
    liquidityUSD: "liquidityUSD",
    volumeUSDWeek: "volumeUSDWeek",
    lpFees24h: "lpFees24h",
    lpApr7d: "lpApr7d"
};
var TrackingWalletTable_LoadingRow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrackingWalletTable_ResponsiveGrid, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
        ]
    });
};
var TrackingWalletTable_TableLoader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_LoadingRow, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_LoadingRow, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_LoadingRow, {})
        ]
    });
};
var TrackingWalletTable_Refresh = [];
var dayProFit = [
    "0"
];
var DayProFit = /*#__PURE__*/ (0,react.createContext)(dayProFit);
var TrackingWalletTable_DataRow = function() {
    var sAccount = function sAccount(dataAddress) {
        if (dataAddress) {
            return "".concat(dataAddress.substring(0, 8), "...").concat(dataAddress.substring(dataAddress.length - 8));
        }
        return "";
    };
    var ref = (0,react.useState)([]), walletInfo = ref[0], setWalletInfo = ref[1];
    var ref1 = (0,react.useState)([]), walletAddresses = ref1[0], setWalletAddresses = ref1[1];
    var ref2 = (0,react.useState)([]), stakeAddr = ref2[0], setStakeAddress = ref2[1];
    var ref3 = (0,react.useState)([]), rewardAddr = ref3[0], setRewardAddress = ref3[1];
    var ref4 = (0,react.useState)({
        tokenBalanceVal: [
            0
        ]
    }), stakeBalances = ref4[0], setStakeBalances = ref4[1];
    var ref5 = (0,react.useState)({
        tokenBalanceVal: [
            0
        ]
    }), rewardBalances = ref5[0], setRewardBalances = ref5[1];
    var tokenAuth = localStorage.getItem("token");
    var valueProfit = (0,react.useContext)(DayProFit);
    var ref6 = (0,react.useState)(0), dataConfig = ref6[0], setDataConfig = ref6[1];
    (0,react.useEffect)(function() {
        var fetchDataConfig = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(valueProfit[valueProfit.length - 1] !== "0")) {
                                _ctx.next = 11;
                                break;
                            }
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return axios_default().get("https://f94oec9qww0r.usemoralis.com:2053/server/functions/getAllRewardPendingPool").then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(res) {
                                    var response;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                response = res.data;
                                                _ctx.next = 3;
                                                return axios_default().get("https://f94oec9qww0r.usemoralis.com:2053/server/functions/getEstRewardByDaysPool?days=".concat(valueProfit[valueProfit.length - 1])).then(function(resV1) {
                                                    var responseV1 = resV1.data;
                                                    setDataConfig(Number(response === null || response === void 0 ? void 0 : response.result) + Number(responseV1 === null || responseV1 === void 0 ? void 0 : responseV1.result));
                                                }).catch(function(error) {
                                                    return console.log(error);
                                                });
                                            case 3:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(res) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(error) {
                                return console.log(error);
                            });
                        case 4:
                            _ctx.next = 9;
                            break;
                        case 6:
                            _ctx.prev = 6;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error(_ctx.t0);
                        case 9:
                            _ctx.next = 19;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.next = 14;
                            return axios_default().get("https://f94oec9qww0r.usemoralis.com:2053/server/functions/getAllRewardPendingPool").then(function(res) {
                                var response = res.data;
                                setDataConfig(response === null || response === void 0 ? void 0 : response.result);
                            }).catch(function(error) {
                                return console.log(error);
                            });
                        case 14:
                            _ctx.next = 19;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t1 = _ctx["catch"](11);
                            console.error(_ctx.t1);
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        6
                    ],
                    [
                        11,
                        16
                    ]
                ]);
            }));
            return function fetchDataConfig() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchDataConfig();
    }, [
        valueProfit.length
    ]);
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    (0,react.useEffect)(function() {
        var getSaleItems = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var resultStake, resultReward;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            if (!(walletAddresses.length > 0)) {
                                _ctx.next = 10;
                                break;
                            }
                            _ctx.next = 4;
                            return FetchStakeBalance(walletAddresses, stakeAddr);
                        case 4:
                            resultStake = _ctx.sent;
                            setStakeBalances(resultStake);
                            _ctx.next = 8;
                            return FetchRewardBalance(walletAddresses, rewardAddr);
                        case 8:
                            resultReward = _ctx.sent;
                            setRewardBalances(resultReward);
                        case 10:
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function getSaleItems() {
                return _ref.apply(this, arguments);
            };
        }();
        getSaleItems();
    }, [
        walletAddresses
    ]);
    var appContext = (0,react.useContext)(Menu/* RefreshCreateGlobal */.t);
    (0,react.useEffect)(function() {
        config/* getTrackingClient.get */.kT.get("").then(function(response) {
            setWalletInfo(response.data.trackings);
            var addresses = response.data.trackings.map(function(wallet) {
                return wallet.address;
            });
            var stakeToken = response.data.trackings.map(function(wallet) {
                return wallet.stakeToken;
            });
            var rewardToken = response.data.trackings.map(function(wallet) {
                return wallet.rewardToken;
            });
            setWalletAddresses(addresses);
            setStakeAddress(stakeToken);
            setRewardAddress(rewardToken);
        });
    }, [
        TrackingWalletTable_Refresh.length,
        appContext.length
    ]);
    var ref7 = (0,react.useState)(0), idDelete = ref7[0], setIdDelete = ref7[1];
    var ref8 = (0,react.useState)(0), idUpdate = ref8[0], setUpdate = ref8[1];
    var rewardAddresses = [];
    rewardAddr.forEach(function(addr) {
        rewardAddresses.push(addr.toLowerCase());
    });
    var rewardSymbol = (0,hooks/* useTokenDatas */._n)(rewardAddresses);
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalTrackingDelete, {
        ID: idDelete,
        onRefresh: function(newValue) {
            return TrackingWalletTable_Refresh.push(newValue);
        }
    })), 1), handleClickDel = ref9[0];
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_ModalTrackingUpdate, {
        id: idUpdate,
        onRefresh: function(newValue) {
            return TrackingWalletTable_Refresh.push(newValue);
        }
    })), 1), handleClickUpdate = ref10[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: walletInfo.map(function(data, index) {
            var ref, ref1;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrackingWalletTable_ResponsiveGrid, {
                children: [
                    tokenAuth !== null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexID, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: index + 1
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexName, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: (0,utils/* getBscScanLink */.s6)(data.address, "address", chainId),
                                    external: true,
                                    children: data.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "hidden",
                                value: data._id
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexAddress, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: (0,utils/* getBscScanLink */.s6)(data.address, "address", chainId),
                                    external: true,
                                    children: sAccount(data.address)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexPriceToken, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexBalance, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            bold: true,
                                            children: (0,formatInfoNumbers/* formatAmount */.d)(Math.round(stakeBalances.tokenBalanceVal[index]), {
                                                isInteger: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexReward, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            bold: true,
                                            children: [
                                                (0,formatInfoNumbers/* formatAmount */.d)(Math.round(rewardBalances.tokenBalanceVal[index]), {
                                                    isInteger: true
                                                }),
                                                " ",
                                                (ref = rewardSymbol[index]) === null || ref === void 0 ? void 0 : ref.symbol
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexIDV2, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: index + 1
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexNameV2, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: (0,utils/* getBscScanLink */.s6)(data.address, "address", chainId),
                                    external: true,
                                    children: data.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexProfitV2, {
                                children: dataConfig && index + 1 === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    children: dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    children: "0"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "hidden",
                                value: data._id
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexAddressV2, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: (0,utils/* getBscScanLink */.s6)(data.address, "address", chainId),
                                    external: true,
                                    children: sAccount(data.address)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexPriceTokenV2, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexBalanceV2, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            bold: true,
                                            children: (0,formatInfoNumbers/* formatAmount */.d)(Math.round(stakeBalances.tokenBalanceVal[index]), {
                                                isInteger: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexRewardV2, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            bold: true,
                                            children: [
                                                (0,formatInfoNumbers/* formatAmount */.d)(Math.round(rewardBalances.tokenBalanceVal[index]), {
                                                    isInteger: true
                                                }),
                                                " ",
                                                (ref1 = rewardSymbol[index]) === null || ref1 === void 0 ? void 0 : ref1.symbol
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    tokenAuth !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexAction, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                justifyContent: "center",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        placement: "top",
                                        title: "Update",
                                        onClick: handleClickUpdate,
                                        onClickCapture: function() {
                                            return setUpdate(data._id);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            color: "primary",
                                            "aria-label": "delete",
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Edit/* default */.Z, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                        placement: "top",
                                        title: "Delete",
                                        onClick: handleClickDel,
                                        onClickCapture: function() {
                                            return setIdDelete(data._id);
                                        },
                                        sx: {
                                            marginLeft: "-1rem"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            color: "primary",
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {})
                                        })
                                    })
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            });
        })
    });
};
var TrackingWalletTable = function(param) {
    var loading = param.loading;
    var router = (0,next_router.useRouter)();
    // for sorting
    var ref = (0,react.useState)(TrackingWalletTable_SORT_FIELD.volumeUSD), sortField = ref[0], setSortField = ref[1];
    var ref1 = (0,react.useState)(true), sortDirection = ref1[0], setSortDirection = ref1[1];
    var t = (0,src/* useTranslation */.$G)().t;
    // pagination
    var ref2 = (0,react.useState)(1), page = ref2[0], setPage = ref2[1];
    var ref3 = (0,react.useState)(1), maxPage = ref3[0], setMaxPage = ref3[1];
    var handleSort = (0,react.useCallback)(function(newField) {
        setSortField(newField);
        setSortDirection(sortField !== newField ? true : !sortDirection);
    }, [
        sortDirection,
        sortField
    ]);
    var arrow = (0,react.useCallback)(function(field) {
        var directionArrow = !sortDirection ? "↑" : "↓";
        return sortField === field ? directionArrow : "";
    }, [
        sortDirection,
        sortField
    ]);
    var tokenAuth = localStorage.getItem("token");
    var ref4 = (0,react.useState)([]), walletInfo = ref4[0], setWalletInfo = ref4[1];
    var appContext = (0,react.useContext)(Menu/* RefreshCreateGlobal */.t);
    (0,react.useEffect)(function() {
        config/* getTrackingClient.get */.kT.get("").then(function(response) {
            setWalletInfo(response.data.trackings);
        });
    }, [
        TrackingWalletTable_Refresh.length,
        appContext.length
    ]);
    var ref5 = (0,react.useState)("30  DAY"), sortBy = ref5[0], setSortBy = ref5[1];
    var sortByItems = [
        {
            label: t("NOW"),
            value: "0"
        },
        {
            label: t("30  DAY"),
            value: "30"
        },
        {
            label: t("60 DAY"),
            value: "60"
        },
        {
            label: t("90 DAY"),
            value: "90"
        }, 
    ];
    var handleChange = function(newOption) {
        setSortBy(newOption.value);
        dayProFit.push(newOption.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* TableWrapper */.y6, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_ResponsiveGrid, {
                children: tokenAuth !== null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexID, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                children: "#"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexName, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Name")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexAddress, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Pool Address")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexPriceToken, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexBalance, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                        color: "secondary",
                                        fontSize: "12px",
                                        bold: true,
                                        textTransform: "uppercase",
                                        children: t("RUN")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexReward, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                        color: "secondary",
                                        fontSize: "12px",
                                        bold: true,
                                        textTransform: "uppercase",
                                        children: t("Other")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexActionTitle, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Action")
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexIDV2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                children: "#"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexNameV2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Name")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexProfitV2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProfit, {
                                options: sortByItems,
                                onOptionChange: handleChange
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexAddressV2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Pool Address")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexPriceTokenV2, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_FlexBalanceV2, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                        color: "secondary",
                                        fontSize: "12px",
                                        bold: true,
                                        textTransform: "uppercase",
                                        children: t("RUN")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexRewardV2, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                        color: "secondary",
                                        fontSize: "12px",
                                        bold: true,
                                        textTransform: "uppercase",
                                        children: t("Other")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexActionV2, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* ClickableColumnHeader */._J, {
                                color: "secondary",
                                fontSize: "12px",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Action")
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* Break */.SS, {}),
            walletInfo.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_DataRow, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* Break */.SS, {}),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_LoadingRow, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* PageButtons */.Ob, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* Arrow */.Eh, {
                                onClick: function() {
                                    setPage(page === 1 ? page : page - 1);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                                    color: page === 1 ? "textDisabled" : "primary"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: t("Page %page% of %maxPage%", {
                                    page: page,
                                    maxPage: maxPage
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* Arrow */.Eh, {
                                onClick: function() {
                                    setPage(page === maxPage ? page : page + 1);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                    color: page === maxPage ? "textDisabled" : "primary"
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingWalletTable_TableLoader, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_Box/* default */.Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var InfoTables_TrackingWalletTable = (TrackingWalletTable);
var TrackingWalletTable_FlexName = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-1"
})(TrackingWalletTable_templateObject1());
var TrackingWalletTable_FlexBalance = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-2"
})(TrackingWalletTable_templateObject2());
var FlexReward = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-3"
})(TrackingWalletTable_templateObject3());
var TrackingWalletTable_FlexID = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-4"
})(TrackingWalletTable_templateObject4());
var TrackingWalletTable_FlexAddress = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-5"
})(TrackingWalletTable_templateObject5());
var FlexPriceToken = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-6"
})(TrackingWalletTable_templateObject6());
var TrackingWalletTable_FlexAction = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-7"
})(TrackingWalletTable_templateObject7());
var TrackingWalletTable_FlexActionTitle = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-8"
})(TrackingWalletTable_templateObject8());
// No login
var TrackingWalletTable_FlexIDV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-9"
})(TrackingWalletTable_templateObject9());
var TrackingWalletTable_FlexNameV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-10"
})(TrackingWalletTable_templateObject10());
var FlexProfitV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-11"
})(TrackingWalletTable_templateObject11());
var SelectProfit = (0,styled_components_browser_esm/* default */.ZP)(Select/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-12"
})(_templateObject12());
var TrackingWalletTable_FlexAddressV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-13"
})(_templateObject13());
var TrackingWalletTable_FlexBalanceV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-14"
})(_templateObject14());
var FlexRewardV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-15"
})(_templateObject15());
var FlexPriceTokenV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-16"
})(_templateObject16());
var FlexActionV2 = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-ae8eb6de-17"
})(_templateObject17());

;// CONCATENATED MODULE: ./src/views/Info/hooks/useTokenLiquidity.ts
/* eslint-disable */ 

var Web3 = __webpack_require__(3283);
var Web3Client = new Web3(new Web3.providers.HttpProvider("https://bsc-dataseed.binance.org/"));
var BNBTokenAddress = "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";
var BUSDTokenAddress = "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56";
// The minimum ABI to get ERC20 Token balance
var minABI = [
    // balanceOf
    {
        constant: true,
        inputs: [
            {
                name: "_owner",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                name: "balance",
                type: "uint256"
            }
        ],
        type: "function"
    }, 
];
var pancakeSwapAbi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amountIn",
                type: "uint256"
            },
            {
                internalType: "address[]",
                name: "path",
                type: "address[]"
            }, 
        ],
        name: "getAmountsOut",
        outputs: [
            {
                internalType: "uint256[]",
                name: "amounts",
                type: "uint256[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }, 
];
var pancakeSwapContract = "0x10ED43C718714eb63d5aA57B78B54704E256024E".toLowerCase();
function calcBNBPrice(amountBNB) {
    return _calcBNBPrice.apply(this, arguments);
}
function _calcBNBPrice() {
    _calcBNBPrice = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(amountBNB) {
        var bnbToSell, amountOutWei, router, amountOut;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    bnbToSell = Web3Client.utils.toWei(amountBNB.toLocaleString(), "ether");
                    ;
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return new Web3Client.eth.Contract(pancakeSwapAbi, pancakeSwapContract);
                case 5:
                    router = _ctx.sent;
                    _ctx.next = 8;
                    return router.methods.getAmountsOut(bnbToSell, [
                        BNBTokenAddress,
                        BUSDTokenAddress
                    ]).call();
                case 8:
                    amountOut = _ctx.sent;
                    amountOutWei = Web3Client.utils.fromWei(amountOut[1]);
                    _ctx.next = 15;
                    break;
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](2);
                    console.log(_ctx.t0);
                case 15:
                    if (amountOutWei) {
                        _ctx.next = 17;
                        break;
                    }
                    return _ctx.abrupt("return", 0);
                case 17:
                    return _ctx.abrupt("return", amountOutWei);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                12
            ]
        ]);
    }));
    return _calcBNBPrice.apply(this, arguments);
}
var getBalance = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(tokenAddress, walletAddress) {
        var contract, result, format;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    contract = new Web3Client.eth.Contract(minABI, tokenAddress);
                    _ctx.next = 3;
                    return contract.methods.balanceOf(walletAddress).call() // 29803630997051883414242659
                    ;
                case 3:
                    result = _ctx.sent;
                    format = Web3Client.utils.fromWei(result) // 29803630.997051883414242659
                    ;
                    return _ctx.abrupt("return", format);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBalance(tokenAddress, walletAddress) {
        return _ref.apply(this, arguments);
    };
}();
var getTokenLiquidity = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var poolBNB, poolBNBPrice, poolBUSD, totalLiquidity;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getBalance(BNBTokenAddress, "0xb73b2c77052Fd08212865Dc436AE8CeDc200244c");
                case 2:
                    poolBNB = _ctx.sent;
                    _ctx.next = 5;
                    return calcBNBPrice(poolBNB);
                case 5:
                    poolBNBPrice = _ctx.sent;
                    _ctx.next = 8;
                    return getBalance(BUSDTokenAddress, "0xB3C793C1470d49569A8d189a946dB5bdB7BB6E4B");
                case 8:
                    poolBUSD = _ctx.sent;
                    totalLiquidity = Number(poolBNBPrice) + Number(poolBUSD);
                    return _ctx.abrupt("return", totalLiquidity);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTokenLiquidity() {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/views/Info/Tokens/TokenPage.tsx
/* eslint-disable no-nested-ternary */ 



function TokenPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 16px;\n  display: grid;\n  grid-template-columns: 260px 1fr;\n  grid-gap: 1em;\n  @media screen and (max-width: 800px) {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr 1fr;\n  }\n"
    ]);
    TokenPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

















var TokenPage = function(param) {
    var routeAddress = param.routeAddress;
    var ref, ref1, ref2;
    var t = (0,src/* useTranslation */.$G)().t;
    var appContext = (0,react.useContext)(Menu/* RefreshCreateGlobal */.t);
    var contextDelete = (0,react.useContext)(RefreshDeleteGlobal);
    var ref3 = (0,react.useState)({
        totalSupply: 0
    }), totalSupplyValue = ref3[0], setTotalSupplyValue = ref3[1];
    var ref4 = (0,react.useState)([]), walletAddresses = ref4[0], setWalletAddresses = ref4[1];
    var ref5 = (0,react.useState)([]), walletInfo = ref5[0], setWalletInfo = ref5[1];
    var ref6 = (0,react.useState)({
        circulatingSupply: 0
    }), circulatingSupplyDisplay = ref6[0], setCirculatingSupplyDisplay = ref6[1];
    var ref7 = (0,react.useState)(0), liquidity = ref7[0], setLiquidity = ref7[1];
    (0,react.useEffect)(function() {
        var getSaleItems = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var result;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return fetchTotalSuppy();
                        case 3:
                            result = _ctx.sent;
                            setTotalSupplyValue(result);
                            _ctx.next = 10;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }));
            return function getSaleItems() {
                return _ref.apply(this, arguments);
            };
        }();
        getSaleItems();
        config/* getProductClient.get */.GI.get("").then(function(response) {
            setWalletInfo(response.data.products);
            var addresses = response.data.products.map(function(wallet) {
                return wallet.address;
            });
            setWalletAddresses(addresses);
        });
    }, [
        appContext.length,
        contextDelete.length
    ]);
    (0,react.useEffect)(function() {
        var getCirculatingSupplyDisplay = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var result;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            if (!(walletAddresses.length > 0)) {
                                _ctx.next = 6;
                                break;
                            }
                            _ctx.next = 4;
                            return FetchCirculatingSupply(walletAddresses);
                        case 4:
                            result = _ctx.sent;
                            setCirculatingSupplyDisplay(result);
                        case 6:
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return function getCirculatingSupplyDisplay() {
                return _ref.apply(this, arguments);
            };
        }();
        getCirculatingSupplyDisplay();
    }, [
        walletAddresses,
        appContext.length,
        contextDelete.length
    ]);
    var ref8 = (0,_sliced_to_array/* default */.Z)(GetDataChart(), 1), dataChart = ref8[0];
    var ref9 = (0,_sliced_to_array/* default */.Z)(GetDataToken(), 1), dataToken = ref9[0];
    var ref10 = (0,react.useState)(0), volume7day = ref10[0], setvolume7day = ref10[1];
    var ref11 = (0,react.useState)(0), volume24h = ref11[0], setVolume24h = ref11[1];
    var ref12 = (0,react.useState)(0), tx24h = ref12[0], setTx24h = ref12[1];
    var ref13 = (0,react.useState)(0), totalTx = ref13[0], setTotalTx = ref13[1];
    (0,react.useEffect)(function() {
        var volumn7d = 0;
        var totalTransaction = 0;
        var vol24h = 0;
        var transaction24h = 0;
        var timeGap = 0;
        for(var i = 1; i < 25; i++){
            var ref, ref1, ref2;
            timeGap = Math.floor(Date.now() / 1000) - ((ref = dataToken[dataToken.length - i]) === null || ref === void 0 ? void 0 : ref.time);
            if (timeGap > 100000) {
                break;
            }
            vol24h += (ref1 = dataToken[dataToken.length - i]) === null || ref1 === void 0 ? void 0 : ref1.volume;
            transaction24h += (ref2 = dataToken[dataToken.length - i]) === null || ref2 === void 0 ? void 0 : ref2.trades;
        }
        for(var i1 = 1; i1 < 169; i1++){
            var ref3, ref4;
            timeGap = Math.floor(Date.now() / 1000) - ((ref3 = dataToken[dataToken.length - i1]) === null || ref3 === void 0 ? void 0 : ref3.time);
            if (timeGap > 604800) {
                break;
            }
            volumn7d += (ref4 = dataToken[dataToken.length - i1]) === null || ref4 === void 0 ? void 0 : ref4.volume;
        }
        for(var i2 = 1; i2 < dataToken.length; i2++){
            var ref5;
            totalTransaction += (ref5 = dataToken[dataToken.length - i2]) === null || ref5 === void 0 ? void 0 : ref5.trades;
        }
        setvolume7day(volumn7d);
        setTotalTx(totalTransaction);
        setVolume24h(vol24h);
        setTx24h(transaction24h);
        var getLiquidity = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var liquid;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getTokenLiquidity();
                        case 2:
                            liquid = _ctx.sent;
                            setLiquidity(liquid);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getLiquidity() {
                return _ref.apply(this, arguments);
            };
        }();
        getLiquidity();
    }, [
        dataChart,
        dataToken
    ]);
    var DataToken = {
        exists: false,
        name: "Run Together Token",
        symbol: "RUN",
        address: "0xc643e83587818202e0fff5ed96d10abbc8bb48e7",
        volumeUSD: 100,
        volumeUSDChange: 100,
        volumeUSDWeek: 100,
        txCount: (ref = dataChart[dataChart.length - 1]) === null || ref === void 0 ? void 0 : ref.trades,
        txCountAll: totalTx,
        liquidityToken: 100,
        liquidityUSD: 1000,
        liquidityUSDChange: 1000,
        priceUSD: (ref1 = dataChart[dataChart.length - 1]) === null || ref1 === void 0 ? void 0 : ref1.price,
        priceUSDChange: 10,
        priceUSDChangeWeek: 10
    };
    return(// <Provider store={store}>
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.Z, {
        symbol: DataToken.symbol,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "space-between",
                mb: "24px",
                flexDirection: [
                    "column",
                    "column",
                    "row"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: [
                        null,
                        null,
                        "flex-end"
                    ],
                    mt: [
                        "8px",
                        "8px",
                        0
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "space-between",
                flexDirection: [
                    "column",
                    "column",
                    "column",
                    "row"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    mb: [
                        "8px",
                        null
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://s2.coinmarketcap.com/static/img/coins/64x64/19638.png",
                                    alt: "Token Run",
                                    width: "32"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    ml: "12px",
                                    bold: true,
                                    lineHeight: "1.5",
                                    fontSize: "40px",
                                    id: "info-token-name-title",
                                    children: DataToken.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    ml: "12px",
                                    lineHeight: "1",
                                    color: "textSubtle",
                                    fontSize: "20px",
                                    children: [
                                        "(",
                                        DataToken.symbol,
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            mt: "8px",
                            ml: "46px",
                            alignItems: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                mr: "16px",
                                bold: true,
                                fontSize: "24px",
                                children: [
                                    "$",
                                    (0,formatInfoNumbers/* formatAmount */.d)((ref2 = dataChart[dataChart.length - 1]) === null || ref2 === void 0 ? void 0 : ref2.price, {
                                        notation: "standard"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentLayout, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            p: "16px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    small: true,
                                    color: "secondary",
                                    fontSize: "12px",
                                    textTransform: "uppercase",
                                    children: t("Liquidity")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    bold: true,
                                    fontSize: "16px",
                                    children: [
                                        "$",
                                        (0,formatInfoNumbers/* formatAmount */.d)(liquidity)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mt: "16px",
                                    bold: true,
                                    color: "secondary",
                                    fontSize: "12px",
                                    textTransform: "uppercase",
                                    children: t("Volume 24H")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    bold: true,
                                    fontSize: "16px",
                                    textTransform: "uppercase",
                                    children: [
                                        "$",
                                        (0,formatInfoNumbers/* formatAmount */.d)(volume24h)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mt: "16px",
                                    bold: true,
                                    color: "secondary",
                                    fontSize: "12px",
                                    textTransform: "uppercase",
                                    children: t("Volume 7D")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    bold: true,
                                    fontSize: "16px",
                                    children: [
                                        "$",
                                        (0,formatInfoNumbers/* formatAmount */.d)(volume7day)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mt: "24px",
                                    bold: true,
                                    color: "secondary",
                                    fontSize: "12px",
                                    textTransform: "uppercase",
                                    children: t("24H / Total transactions")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    bold: true,
                                    fontSize: "16px",
                                    children: [
                                        (0,formatInfoNumbers/* formatAmount */.d)(tx24h, {
                                            isInteger: true
                                        }),
                                        " / ",
                                        totalTx
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mt: "16px",
                                    bold: true,
                                    color: "secondary",
                                    fontSize: "12px",
                                    textTransform: "uppercase",
                                    children: t("Total Supply")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    fontSize: "16px",
                                    children: (0,formatInfoNumbers/* formatAmount */.d)(totalSupplyValue.totalSupply, {
                                        isInteger: true
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    mt: "16px",
                                    bold: true,
                                    color: "secondary",
                                    fontSize: "12px",
                                    textTransform: "uppercase",
                                    children: t("Circulating Supply")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    bold: true,
                                    fontSize: "16px",
                                    children: (0,formatInfoNumbers/* formatAmount */.d)(Math.round(circulatingSupplyDisplay.circulatingSupply), {
                                        isInteger: true
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartCard/* default */.Z, {
                        variant: "token",
                        chartData: DataChart,
                        tokenData: DataToken,
                        tokenPriceData: dataChart
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "lg",
                mb: "16px",
                mt: "40px",
                children: t("Team Wallets")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTables_TeamWalletTable, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "lg",
                mb: "16px",
                mt: "40px",
                children: t("Tracking Wallets")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTables_TrackingWalletTable, {})
        ]
    }));
};
/* harmony default export */ var Tokens_TokenPage = (TokenPage);
var ContentLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bda1d5c9-0"
})(TokenPage_templateObject());

// EXTERNAL MODULE: ./src/views/Info/index.tsx + 7 modules
var Info = __webpack_require__(65449);
;// CONCATENATED MODULE: ./src/pages/info/tokens/[address].tsx



var _address_TokenPage = function(param) {
    var address = param.address;
    if (!address) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tokens_TokenPage, {
        routeAddress: address
    });
};
_address_TokenPage.Layout = Info/* InfoPageLayout */.O;
var __N_SSG = true;
/* harmony default export */ var _address_ = (_address_TokenPage);


/***/ }),

/***/ 5004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97114);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84091);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38144);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44850);
/* harmony import */ var views_Info_components_InfoCharts_LineChart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45091);
/* harmony import */ var views_Info_components_InfoCharts_BarChart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55224);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8253);
/* harmony import */ var utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56245);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42227);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);









var CandleChart = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2298), __webpack_require__.e(3136), __webpack_require__.e(5491)]).then(__webpack_require__.bind(__webpack_require__, 85491));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85491)
            ];
        }
    },
    ssr: false
});
var ChartView;
(function(ChartView) {
    ChartView[ChartView["LIQUIDITY"] = 0] = "LIQUIDITY";
    ChartView[ChartView["VOLUME"] = 1] = "VOLUME";
    ChartView[ChartView["PRICE"] = 2] = "PRICE";
})(ChartView || (ChartView = {}));
var ChartCard = function(param) {
    var variant = param.variant, chartData = param.chartData, tokenData = param.tokenData, tokenPriceData = param.tokenPriceData;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(ChartView.PRICE), view = ref[0], setView = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), hoverValue = ref1[0], setHoverValue = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), hoverDate = ref2[0], setHoverDate = ref2[1];
    var ref3 = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)(), t = ref3.t, locale = ref3.currentLanguage.locale;
    var currentDate = new Date().toLocaleString(locale, {
        month: "short",
        year: "numeric",
        day: "numeric"
    });
    var formattedTvlData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (chartData) {
            return chartData.map(function(day) {
                return {
                    time: (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(day.date),
                    value: day.liquidityUSD
                };
            });
        }
        return [];
    }, [
        chartData
    ]);
    var formattedVolumeData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (chartData) {
            return chartData.map(function(day) {
                return {
                    time: (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(day.date),
                    value: day.volumeUSD
                };
            });
        }
        return [];
    }, [
        chartData
    ]);
    var getLatestValueDisplay = function() {
        var valueToDisplay = null;
        if (hoverValue) {
            valueToDisplay = (0,utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_5__/* .formatAmount */ .d)(hoverValue);
        } else if (view === ChartView.VOLUME && formattedVolumeData.length > 0) {
            var ref;
            valueToDisplay = (0,utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_5__/* .formatAmount */ .d)((ref = formattedVolumeData[formattedVolumeData.length - 1]) === null || ref === void 0 ? void 0 : ref.value);
        } else if (view === ChartView.LIQUIDITY && formattedTvlData.length > 0) {
            var ref1;
            valueToDisplay = (0,utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_5__/* .formatAmount */ .d)((ref1 = formattedTvlData[formattedTvlData.length - 1]) === null || ref1 === void 0 ? void 0 : ref1.value);
        } else if (view === ChartView.PRICE && (tokenData === null || tokenData === void 0 ? void 0 : tokenData.priceUSD)) {
            valueToDisplay = (0,utils_formatInfoNumbers__WEBPACK_IMPORTED_MODULE_5__/* .formatAmount */ .d)(tokenData.priceUSD);
        }
        return valueToDisplay ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            fontSize: "24px",
            bold: true,
            children: [
                "$",
                valueToDisplay
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
            height: "36px",
            width: "128px"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                flexDirection: "column",
                px: "24px",
                pt: "24px",
                children: [
                    getLatestValueDisplay(),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        small: true,
                        color: "secondary",
                        children: hoverDate || currentDate
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                px: "24px",
                height: variant === "token" ? "250px" : "335px",
                children: view === ChartView.LIQUIDITY ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(views_Info_components_InfoCharts_LineChart__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    data: formattedTvlData,
                    setHoverValue: setHoverValue,
                    setHoverDate: setHoverDate
                }) : view === ChartView.VOLUME ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(views_Info_components_InfoCharts_BarChart__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    data: formattedVolumeData,
                    setHoverValue: setHoverValue,
                    setHoverDate: setHoverDate
                }) : view === ChartView.PRICE ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CandleChart, {
                    data: tokenPriceData,
                    setValue: setHoverValue,
                    setLabel: setHoverDate
                }) : null
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChartCard);


/***/ }),

/***/ 80950:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 89214:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96419:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 56353:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 8623:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 7748:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 85568:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 69386:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31616:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 29120:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 46586:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 56619:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 77108:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 43503:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 56773:
/***/ (function() {

/* (ignored) */

/***/ })

}]);